import { render, staticRenderFns } from "./TotalPendingCases.vue?vue&type=template&id=369a0912"
import script from "./TotalPendingCases.vue?vue&type=script&lang=js"
export * from "./TotalPendingCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports